import { Directive, Input } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Directive()  
export class BaseRuleContainerComponent {
  @Input() isDirty: BehaviorSubject<boolean>;
  @Input() isSaveEnabled: BehaviorSubject<boolean>;
  @Input() isBinEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  componentName: string;
  constructor() { }

  onSave(): Observable<boolean> {
    return of(false);
  }
}
